<span [ngSwitch]="value">
    <span class="badge bg-success" *ngSwitchCase="logTypeEnum.INFO"> {{'logTypeEnumValue.'+value | translate}}</span>
    <span class="badge bg-danger" *ngSwitchCase="logTypeEnum.ERROR"> {{'logTypeEnumValue.'+value | translate}}</span>
    <span class="badge bg-warning" *ngSwitchCase="logTypeEnum.WARNING"> {{'logTypeEnumValue.'+value | translate}}</span>
    <span class="badge bg-warning" *ngSwitchCase="logTypeEnum.SUSPICIOUS"> {{'logTypeEnumValue.'+value | translate}}</span>
    <span class="badge bg-info" *ngSwitchDefault> {{'logTypeEnumValue.'+value | translate}}</span>
</span>